var _desc, _g, _text, _text2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBeadcompass(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 500,
    height: 90,
    viewBox: "0 0 500 90",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "BeadCompass") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "desc"
  }, "Logo de BeadCompass: una br\xFAjula formada por beads conectados.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(5 5)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 34,
    fill: "#143f68",
    stroke: "#49c5dc",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 8v64M8 40h64M17 17l46 46M63 17 17 63",
    stroke: "#8fe5e0",
    strokeWidth: 1.5,
    opacity: 0.55
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 14 51 47 40 43 29 47Z",
    fill: "#f4b400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 66 29 33 40 37 51 33Z",
    fill: "#25b2d8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 7,
    fill: "#f5f7ff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 14,
    r: 3.5,
    fill: "#f4b400"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66,
    cy: 40,
    r: 3.5,
    fill: "#12ad9f"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 66,
    r: 3.5,
    fill: "#25b2d8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 40,
    r: 3.5,
    fill: "#ef1748"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 94,
    y: 57,
    fill: "#f5f7ff",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 42,
    fontWeight: 600,
    letterSpacing: 1
  }, "bead")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 207,
    y: 57,
    fill: "#8fe5e0",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 42,
    fontWeight: 300,
    letterSpacing: 1
  }, "compass")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeadcompass);
export default __webpack_public_path__ + "static/media/beadcompass.c97434d1b25da40f8d48b4d51bd7d51e.svg";
export { ForwardRef as ReactComponent };